import * as yup from 'yup';


export const emailGoalsFormValidation = yup.object().shape(
  {
    email: yup
             .string()
             .email()
             .required(),
    comment: yup
             .string(),
  },
);